// import { useContext } from "react";

import styled from "styled-components";
import { device } from "src/styles/device";
import font from "src/styles/font";

// import Link from "next/link";
// import { useRouter } from 'next/router'

// import { LoadingContext } from "context/LoadingContext";

// import { replaceProductUrl } from "lib/common";

const S = {};

S.BlogItem = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  /* padding-right: 24px; // left, right padding should be equal for each element, to prevent weird calculate blog card size */
  max-width: 100%;

  width: calc(100vw / 3);

  @media ${device.tabletL} {
    width: calc(100vw / 4);
  }

  @media ${device.mobileL} {
    width: calc(100vw / 2);
  }
`;

S.BlogImageWrapper = styled.div`
  position: relative;
  padding-top: 100%;
  border-radius: 16px;
  overflow: hidden;
  background-color: #f3f1f2;

  &::before {
    content: "Preview";
    color: #bcbcc0;
    font-size: ${font.size.lg};
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

S.BlogImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
  object-fit: cover;
`;

S.BlogTitle = styled.h2`
  margin-top: 24px;
  font-size: 1rem;
  white-space: nowrap;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

S.BlogExcerpt = styled.p`
  margin-top: 8px;
  font-size: 0.875rem;
  color: #6c6c70;
  word-wrap: break-word;
`;

S.BlogView = styled.div`
  position: absolute;
  top: 15px;
  right: 25px;
`;

S.BlogTagGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

S.BlogTag = styled.span`
  display: inline-flex;
  padding: 8px 16px;
  background-color: #f3f1f2;
  border-radius: 16px;
  font-size: 0.75rem;
  flex-shrink: 0;
  margin-bottom: 10px;

  &:not(:last-child) {
    margin-right: 10px;
  }
`;

const BlogCard = (props) => {
  const {
    className,
    id,
    image,
    title,
    excerpt,
    tags = [],
    views,
    ...rest
  } = props;
  // const router = useRouter()
  // const { setIsLoading } = useContext(LoadingContext)
  const sampleHashtag = [
    { name: "Dummy" },
    { name: "Dummy" },
    { name: "Dummy" },
  ];

  return (
    // <Link href={`/blog/${id}`}>
    <S.BlogItem
      className={className}
      {...rest}
      // onClick={() => setIsLoading(true)}
      // onClick={() => router.push(`/blog/${title}=${id}`)}
    >
      <S.BlogImageWrapper>
        {image && <S.BlogImage src={image} alt="" />}
      </S.BlogImageWrapper>
      <S.BlogTitle>{title}</S.BlogTitle>
      <S.BlogExcerpt>{excerpt}</S.BlogExcerpt>
      <S.BlogTagGroup>
        {tags.length !== 0
          ? tags.map((tag, index) => (
              <S.BlogTag key={index}>#{tag.name}</S.BlogTag>
            ))
          : sampleHashtag.map((tag, index) => (
              <S.BlogTag key={index}>#{tag.name}</S.BlogTag>
            ))}
      </S.BlogTagGroup>
      <S.BlogView>{views}</S.BlogView>
    </S.BlogItem>
    // </Link>
  );
};

export default BlogCard;
